// extracted by mini-css-extract-plugin
export var askAiIcon = "_qw-9";
export var container = "_qw-0";
export var groupSeparator = "_qw-a";
export var highlight = "_qw-4";
export var resultIcon = "_qw-5";
export var resultItem = "_qw-7";
export var resultSubtitle = "_qw-3";
export var resultTitle = "_qw-2";
export var resultsList = "_qw-1";
export var searchGroup = "_qw-6";
export var selected = "_qw-8";